import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  DeleteCategory,
  GetAllCategory,
  SearchForCategorysByName,
} from '../../../redux/admin/category/category_services_syn';
import {
  SingleTableLoader,
  TableLoader,
} from '../../../component/loader/Table_Loader';
import EmptyComponent from '../../../component/EmptyComponent';
import moment from 'moment/moment';
import PaginationComponent from '../../../component/pagination/PaginationComponent';
import {
  updateCategoryDetails,
  updateCategoryId,
} from '../../../redux/admin/category/category_slices';
import { useDebouncedCallback } from 'use-debounce';

const Category = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [deletePayload, setDeletePayload] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const [searchCategory, setSearchCategory] = useState('');

  const {
    completeCategorySearch,
    completeCategory,
    category_loader,
    categoryDeleteLoader,
    category_page,
    category_limit,
    editCategoryId,
  } = useSelector((state) => state.category);

  useEffect(() => {
    dispatch(GetAllCategory({ page: category_page, limit: category_limit }));

    return () => {};
  }, []);

  const handleDeleteClick = (item) => {
    console.log('Delete clicked:', item);
    setSelectedItem(item);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = () => {
    if (selectedItem) {
      dispatch(updateCategoryId(selectedItem?._id));
      dispatch(
        DeleteCategory({
          ...selectedItem,
          id: selectedItem?._id,
        })
      );
      setShowDeleteModal(false);
      setSelectedItem(null);
    }
  };

  const handlePageChange = (page) => {
    dispatch(
      GetAllCategory({
        page: page,
        limit: category_limit,
      })
    );
  };

  const debounced = useDebouncedCallback(
    async (value) => {
      if (value) {
        dispatch(
          SearchForCategorysByName({
            name: value,
            page: 0,
            limit: category_limit,
          })
        );
      }
    },
    // delay in ms
    1000
  );

  const handleInputChange = (e) => {
    const value = e.target.value;
    setSearchCategory(value);

    if (value) {
      debounced(value);
    }
  };

  return (
    <>
      <div class="card max-w-[500px]">
        <div class="card-header">
          <form class="chat-search pb-0">
            <div class="chat-search-box">
              <input
                value={searchCategory || ''}
                class="form-control"
                type="text"
                name="search"
                placeholder="Search ..."
                onChange={handleInputChange}
              />

              <button type="submit" class="btn btn-sm btn-link search-icon p-0">
                <i class="bx bx-search-alt"></i>
              </button>
            </div>
          </form>
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-header d-flex justify-content-between align-items-center gap-1">
              <h4 class="card-title flex-grow-1">All Categories List</h4>

              <NavLink to="/admin_dashboard/create_category">
                <a class="btn btn-sm btn-primary">Add Category</a>
              </NavLink>
            </div>
            <div>
              {category_loader ? (
                <TableLoader
                  headerArray={[
                    'Categories',
                    'Slug',
                    'Admin Type',
                    'Date',
                    'Description',
                    'Action',
                  ]}
                  itemArray={[1, 2, 3, 4, 5, 6]}
                />
              ) : (
                <div class="table-responsive">
                  <table class="table align-middle mb-0 table-hover table-centered">
                    <thead class="bg-light-subtle">
                      <tr>
                        <th style={{ width: '20px' }}>
                          <div class="form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              id="customCheck1"
                            />
                            <label
                              class="form-check-label"
                              for="customCheck1"
                            ></label>
                          </div>
                        </th>
                        <th>Categories</th>
                        <th>Slug</th>
                        <th>Admin Type</th>
                        <th>Date</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchCategory ? (
                        completeCategorySearch?.docs?.length <= 0 ? (
                          <EmptyComponent />
                        ) : (
                          completeCategorySearch?.docs?.map((item, key) => (
                            <>
                              {item?._id !== editCategoryId ? (
                                <tr key={key}>
                                  <td>
                                    <div class="form-check">
                                      <input
                                        type="checkbox"
                                        class="form-check-input"
                                        id="customCheck2"
                                      />
                                      <label
                                        class="form-check-label"
                                        for="customCheck2"
                                      ></label>
                                    </div>
                                  </td>
                                  <td>
                                    <div class="d-flex align-items-center gap-2">
                                      <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                        <img
                                          src={item?.category_image}
                                          alt=""
                                          class="avatar-md"
                                        />
                                      </div>
                                      <p class="text-dark fw-medium fs-15 mb-0">
                                        {item?.name}
                                      </p>
                                    </div>
                                  </td>
                                  <td>{item?.slug}</td>
                                  <td>{item?.adminName}</td>
                                  <td>
                                    {moment(item?.date).format('dd MMM yyyy')}
                                  </td>
                                  <td>{item?.description}</td>
                                  <td>
                                    <div class="d-flex gap-2">
                                      <a
                                        onClick={() => {
                                          dispatch(updateCategoryDetails(item));
                                          navigate(
                                            '/admin_dashboard/edit_category'
                                          );
                                        }}
                                        class="btn btn-soft-primary btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:pen-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>

                                      <a
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleDeleteClick(item);
                                        }}
                                        className="btn btn-soft-danger btn-sm"
                                      >
                                        <iconify-icon
                                          icon="solar:trash-bin-minimalistic-2-broken"
                                          class="align-middle fs-18"
                                        ></iconify-icon>
                                      </a>
                                    </div>
                                  </td>
                                </tr>
                              ) : (
                                <SingleTableLoader
                                  itemArray={[1, 2, 3, 4, 5, 6]}
                                />
                              )}
                            </>
                          ))
                        )
                      ) : completeCategory?.docs?.length <= 0 ? (
                        <EmptyComponent />
                      ) : (
                        completeCategory?.docs?.map((item, key) => (
                          <>
                            {item?._id !== editCategoryId ? (
                              <tr key={key}>
                                <td>
                                  <div class="form-check">
                                    <input
                                      type="checkbox"
                                      class="form-check-input"
                                      id="customCheck2"
                                    />
                                    <label
                                      class="form-check-label"
                                      for="customCheck2"
                                    ></label>
                                  </div>
                                </td>
                                <td>
                                  <div class="d-flex align-items-center gap-2">
                                    <div class="rounded bg-light avatar-md d-flex align-items-center justify-content-center">
                                      <img
                                        src={item?.category_image}
                                        alt=""
                                        class="avatar-md"
                                      />
                                    </div>
                                    <p class="text-dark fw-medium fs-15 mb-0">
                                      {item?.name}
                                    </p>
                                  </div>
                                </td>
                                <td>{item?.slug}</td>
                                <td>{item?.adminName}</td>
                                <td>
                                  {moment(item?.date).format('dd MMM yyyy')}
                                </td>
                                <td>{item?.description}</td>
                                <td>
                                  <div class="d-flex gap-2">
                                    <a
                                      onClick={() => {
                                        dispatch(updateCategoryDetails(item));
                                        navigate(
                                          '/admin_dashboard/edit_category'
                                        );
                                      }}
                                      class="btn btn-soft-primary btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:pen-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>

                                    <a
                                      onClick={(e) => {
                                        e.preventDefault();
                                        handleDeleteClick(item);
                                      }}
                                      className="btn btn-soft-danger btn-sm"
                                    >
                                      <iconify-icon
                                        icon="solar:trash-bin-minimalistic-2-broken"
                                        class="align-middle fs-18"
                                      ></iconify-icon>
                                    </a>
                                  </div>
                                </td>
                              </tr>
                            ) : (
                              <SingleTableLoader
                                itemArray={[1, 2, 3, 4, 5, 6]}
                              />
                            )}
                          </>
                        ))
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div class="card-footer border-top">
              <nav aria-label="Page navigation example">
                <PaginationComponent
                  currentPage={completeCategory?.page}
                  totalItems={completeCategory?.totalDocs}
                  pageSize={category_limit}
                  handlePageChange={handlePageChange}
                />
              </nav>
            </div>
          </div>
        </div>
      </div>
      {showDeleteModal && (
        <div
          className="modal-overlay"
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
          }}
        >
          <div
            className="modal-container"
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '400px',
            }}
          >
            <div className="modal-header">
              <h5>Delete Category</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowDeleteModal(false)}
              />
            </div>
            <div className="modal-body" style={{ padding: '20px 0' }}>
              <p>
                Are you sure you want to delete{' '}
                <strong>{selectedItem?.name}</strong>?
              </p>
            </div>
            <div
              className="modal-footer"
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
              }}
            >
              <button
                className="btn btn-light"
                onClick={() => setShowDeleteModal(false)}
              >
                Cancel
              </button>
              <button className="btn btn-danger" onClick={handleConfirmDelete}>
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Category;
